import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "v-inspections" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "modal__body" }
const _hoisted_6 = {
  key: 0,
  class: "modal__body--file"
}
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "action" }
const _hoisted_10 = {
  key: 1,
  class: "modal__body--file"
}
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "file" }
const _hoisted_13 = { class: "file__name" }
const _hoisted_14 = { class: "file__size" }
const _hoisted_15 = { class: "action" }
const _hoisted_16 = {
  key: 2,
  class: "modal__body--input"
}
const _hoisted_17 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = { class: "dropdown" }
const _hoisted_21 = { style: {"margin-bottom":"16px"} }
const _hoisted_22 = { style: {"margin-bottom":"16px"} }
const _hoisted_23 = { style: {"margin-bottom":"16px"} }
const _hoisted_24 = { class: "comment" }
const _hoisted_25 = { style: {"display":"flex","justify-content":"flex-end","width":"100%","gap":"16px"} }

import {
  InfoCircle,
  SearchMd,
  File06,
  Download01,
  Trash01,
  FilePlus02,
  Plus,
} from "utruckin-icons";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { ITeam } from "@/features/teams/team.types";
import { useTeamStore } from "@/features/teams/team.store";
import { useInspectionStore } from "@/features/inspections/inspection.store";
import {
  IInspectionItem,
  IManualInspection,
} from "@/features/inspections/inspection.types";
import CommonTable from "@/components/common/CommonTable.vue";
import { DateTime } from "luxon";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useNotification } from "@/utils/notification";
import { useUserStore } from "@/features/users/user.store";
import CustomTab from "@/components/custom/CustomTab.vue";
import { ICompany } from "@/features/company/company.types";
import { useCompanyStore } from "@/features/company/company.store";
import { IDriver } from "@/features/drivers/drivers.types";
import { useDriverStore } from "@/features/drivers/drivers.store";
import CustomTableDropdown from "@/components/custom/CustomTableDropdown.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import { useAppStore } from "@/store/app.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'InspectionsView',
  setup(__props) {

const teamStore = useTeamStore();
const companyStore = useCompanyStore();
const inspectionStore = useInspectionStore();
const userStore = useUserStore();
const driverStore = useDriverStore();
const appStore = useAppStore();

const { pushNotification } = useNotification();

const inspections = ref<IInspectionItem[]>([]);
const inspectionLoading = ref(false);
const hasMore = ref(true);
const loadMoreTrigger = ref<HTMLElement | null>(null);
const bodyRef = ref<HTMLElement | null>(null);
const teams = ref<ITeam[]>([]);
const teamLoading = ref(false);
const companies = ref<ICompany[]>([]);
const companyLoading = ref(false);
const drivers = ref<IDriver[]>([]);
const driverLoading = ref(false);
const team = ref<string | null>(null);
const search = ref<string>("");
const modalVisible = ref<boolean>(false);
const modalItem = ref<IInspectionItem>();
const modalLoading = ref(false);
const fileInput = ref();
const file = ref<any>(null);
const comment = ref<string | boolean>("");

const addModal = ref<boolean>(false);
const addModalItem = ref<IManualInspection>({
  company_id: "",
  company_name: "",
  driver_id: "",
  driver_name: "",
  filecode: "",
  type: "",
  status: "",
  start_date: "",
  end_date: "",
  processed_time: "",
  comment: "",
});
const addModalLoading = ref<boolean>(false);

let searchCompanyTimer: ReturnType<typeof setTimeout> | null = null;
let searchDriverTimer: ReturnType<typeof setTimeout> | null = null;

const activeTab = ref<number>(0);
const tabs = [
  { label: "All", value: 0 },
  { label: "With file", value: 1 },
  { label: "No file", value: 2 },
];

let searchTimer: ReturnType<typeof setTimeout> | null = null;
let observer: IntersectionObserver | null = null;

const teamItems = computed(() =>
  teams.value.map((t) => ({ value: t.id, name: t.name }))
);

const saveIsDisabled = computed(() => {
  return (file.value && file.value.name && file.value.size) || comment.value;
});

const addSaveDisabled = computed(() => {
  return (
    addModalItem.value?.company_id &&
    addModalItem.value.driver_id &&
    addModalItem.value.start_date &&
    addModalItem.value.end_date &&
    addModalItem.value.processed_time
  );
});

const isAdmin = computed(() => {
  return (
    userStore.userProfile?.role == "admin" ||
    userStore.userProfile?.role == "super_admin" ||
    userStore.userProfile?.role == "supervisor"
  );
});

const companyItems = computed(() =>
  (companies.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.provider_name,
  }))
);

const driverItems = computed(() =>
  (drivers.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.truck_number,
  }))
);

function datepickerToUtcDateOnly(d: any) {
  return d
    ? DateTime.fromISO(d, {
        zone: "utc",
      })
        .setZone("America/New_York")
        .toFormat("MMM d, HH:mm")
    : "-";
}

function datepickerToUtcDateOnlyWithoutTime(d: any) {
  return DateTime.fromISO(d, {
    zone: "utc",
  })
    .setZone("America/New_York")
    .toFormat("MMM d");
}

const getList = async () => {
  const [fetchedTeams, fetchedCompanies] = await Promise.all([
    teamStore.getTeams(teamLoading),
    companyStore.getSimpleCompanies(companyLoading),
  ]);

  teams.value = fetchedTeams;
  companies.value = fetchedCompanies.items;

  if (inspectionLoading.value || !hasMore.value) return;

  const res = await inspectionStore.getInspections(inspectionLoading);

  inspections.value.push(...res.items);

  const meta = res.meta;
  hasMore.value = meta?.page * meta.per_page < meta.total;

  inspectionStore.commonFilter.page =
    (inspectionStore.commonFilter.page as number) + 1;
};

const reload = async () => {
  inspections.value = [];
  hasMore.value = true;
  inspectionStore.commonFilter.page = 1;

  await getList();
};

const openModal = (item: IInspectionItem) => {
  modalItem.value = item;
  if (item.report_uploaded) {
    file.value = {};
  }
  comment.value = item.comment;
  modalVisible.value = true;
};

const addInspection = () => {
  addModal.value = true;
  addModalItem.value = {
    company_id: "",
    company_name: "",
    driver_id: "",
    driver_name: "",
    filecode: "",
    type: "",
    status: "",
    start_date: "",
    end_date: "",
    processed_time: "",
    comment: "",
  };
};

const closeAddModal = () => {
  addModal.value = false;
  addModalItem.value = {
    company_id: "",
    company_name: "",
    driver_id: "",
    driver_name: "",
    filecode: "",
    type: "",
    status: "",
    start_date: "",
    end_date: "",
    processed_time: "",
    comment: "",
  };
};

const saveAddInspection = () => {
  if (!addSaveDisabled.value) return;

  if (addModalItem.value) {
    if (addModalItem.value.company_name) {
      addModalItem.value.company_id = "";
      delete addModalItem.value.company_id;
    } else {
      delete addModalItem.value.company_name;
    }

    if (addModalItem.value.driver_name) {
      addModalItem.value.driver_id = "";
      delete addModalItem.value.driver_id;
    } else {
      delete addModalItem.value.driver_name;
    }

    inspectionStore.createManualInspection(
      addModalLoading,
      addModalItem.value,
      async (data: any) => {
        if (data) {
          pushNotification("Successfully created", "success");
          closeAddModal();
          await getList();
        }
      }
    );
  }
};

const closeModal = () => {
  modalVisible.value = false;
  file.value = null;
  comment.value = "";
};

const handleFile = (e: any) => {
  file.value = e.target.files?.[0] ?? null;
};

const handleDrop = (event: any) => {
  const files = event.dataTransfer?.files;

  if (!files?.length) return;

  const newFile = files[0];

  file.value = newFile ?? null;
};

const downloadFile = async () => {
  const data = await inspectionStore.downloadReport(
    modalLoading,
    modalItem.value?.id as string
  );
  if (data) {
    const fileUrl = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", modalItem.value?.report_filename as string);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
  }
};

const searchCompany = (val: string) => {
  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);
  searchCompanyTimer = setTimeout(async () => {
    companyStore.commonSimpleFilter.search = val;
    companies.value = (
      await companyStore.getSimpleCompanies(companyLoading)
    ).items;
  }, 400);
};

const searchDriver = (val: string) => {
  if (addModalItem.value.company_name) return;
  if (searchDriverTimer) clearTimeout(searchDriverTimer);
  searchDriverTimer = setTimeout(async () => {
    driverStore.commonSimpleFilter.search = val;
    const [fetchedDrivers] = await Promise.all([
      driverStore.getSimpleDrivers(driverLoading),
    ]);

    drivers.value = fetchedDrivers.items;
  }, 400);
};

const deleteFile = async () => {
  const data = await inspectionStore.deleteReport(
    modalLoading,
    modalItem.value?.id as string
  );

  if (data) {
    pushNotification("Successfully uploaded", "success");
    closeModal();
    await reload();
  }
};

const save = async () => {
  let data;
  let commentData;
  if (file.value && file.value.name) {
    data = await inspectionStore.uploadReport(
      modalLoading,
      modalItem.value?.id as string,
      file.value as File
    );
  }

  if (comment.value) {
    commentData = await inspectionStore.updateComment(
      modalLoading,
      modalItem.value?.id as string,
      { text: comment.value }
    );
  }

  if (data) {
    pushNotification("Successfully uploaded", "success");
  }

  if (commentData) {
    pushNotification("Successfully updated", "success");
  }

  closeModal();
  await reload();
};

onMounted(async () => {
  if (userStore.userProfile && userStore.userProfile.team_id) {
    team.value = userStore.userProfile.team_id;
    inspectionStore.commonFilter.team_id = userStore.userProfile.team_id;
  }

  inspections.value = [];
  hasMore.value = true;
  inspectionStore.commonFilter.page = 1;

  await getList();

  observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        getList();
      }
    },
    {
      root: bodyRef.value,
      rootMargin: "200px",
      threshold: 0,
    }
  );

  if (loadMoreTrigger.value) {
    observer.observe(loadMoreTrigger.value);
  }
});

onUnmounted(() => {
  observer?.disconnect();
});

watch(search, (val) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(async () => {
    inspectionStore.commonFilter.search = val;
    await reload();
  }, 400);
});

watch(team, async (val) => {
  inspectionStore.commonFilter.team_id = val as string;
  await reload();
});

watch(
  () => activeTab.value,
  async (newVal) => {
    if (inspectionStore.commonFilter) {
      if (newVal == 0) {
        inspectionStore.commonFilter.report_uploaded = null;
      } else inspectionStore.commonFilter.report_uploaded = newVal == 1;

      await reload();
    }
  }
);

watch(
  () => addModalItem.value?.company_id,
  async (val) => {
    const newVal = companies.value.some(
      (item) => item.id.toLowerCase() === val
    );

    drivers.value = [];
    addModalItem.value.driver_id = "";

    if (!newVal) {
      addModalItem.value.company_name = val;
      driverStore.commonSimpleFilter.company_id = "";
      drivers.value = [];
    } else {
      if (val) {
        driverStore.commonSimpleFilter.company_id = val;
        const [fetchedDrivers] = await Promise.all([
          driverStore.getSimpleDrivers(driverLoading),
        ]);

        drivers.value = fetchedDrivers.items;
      }
    }
  }
);

watch(
  () => addModalItem.value.driver_id,
  (val) => {
    const newVal = drivers.value.some((item) => item.id.toLowerCase() === val);

    if (!newVal) {
      addModalItem.value.driver_name = val;
    }
  }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: "Search",
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: team.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
        items: teamItems.value,
        label: "Team",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomTab, {
        tabs: tabs,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(CommonButton, {
        type: "primary",
        label: "Add Inspection",
        prepend: true,
        "prepend-icon": _unref(Plus),
        onClick: addInspection
      }, null, 8, ["prepend-icon"])
    ]),
    _createElementVNode("div", {
      class: "body",
      ref_key: "bodyRef",
      ref: bodyRef
    }, [
      _createVNode(CommonTable, {
        headers: _unref(inspectionStore).inspectionsHeaders,
        loading: inspectionLoading.value,
        items: inspections.value
      }, {
        id: _withCtx(({ index }) => [
          _createElementVNode("span", null, _toDisplayString(index + 1), 1)
        ]),
        last_driver_task_completed_time: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.last_driver_task_completed_time) || "-"), 1)
        ]),
        created_time: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
        ]),
        last_driver_task_user_name: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.last_driver_task_user_name || "-"), 1)
        ]),
        period: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(datepickerToUtcDateOnlyWithoutTime(item.start_date) +
            " - " +
            datepickerToUtcDateOnlyWithoutTime(item.end_date)), 1)
        ]),
        processed_time: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.processed_time)), 1)
        ]),
        log_violations_during_inspection_count: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(item.log_violations_during_inspection_count), 1)
        ]),
        has_eld_history_changes_after_last_task: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.has_eld_history_changes_after_last_task ? "Yes" : "No"), 1)
        ]),
        type: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(item.type == "manual" ? "Manual" : "Auto"), 1)
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["action", item.report_uploaded ? 'uploaded' : '']),
            onClick: ($event: any) => (openModal(item))
          }, [
            _createVNode(_unref(InfoCircle), { size: 18 })
          ], 10, _hoisted_4)
        ]),
        _: 1
      }, 8, ["headers", "loading", "items"]),
      _createElementVNode("div", {
        ref_key: "loadMoreTrigger",
        ref: loadMoreTrigger
      }, null, 512)
    ], 512),
    _createVNode(CommonModal, {
      modelValue: modalVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((modalVisible).value = $event)),
      title: "Add file",
      onClose: closeModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(CommonButton, {
            "is-disabled": !saveIsDisabled.value,
            type: "primary",
            label: "Save",
            onClicked: save
          }, null, 8, ["is-disabled"]),
          _createVNode(CommonButton, {
            type: "outline",
            label: "Back",
            onClicked: closeModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", null, [
            _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Company"),
                _createElementVNode("th", null, "Driver"),
                _createElementVNode("th", null, "Date"),
                _createElementVNode("th", null, "File")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(modalItem.value?.company_name), 1),
                _createElementVNode("td", null, _toDisplayString(modalItem.value?.driver_name), 1),
                _createElementVNode("td", null, _toDisplayString(datepickerToUtcDateOnly(modalItem.value?.created_time as string)), 1),
                _createElementVNode("td", null, _toDisplayString(modalItem.value?.report_uploaded ? "1" : "0"), 1)
              ])
            ])
          ]),
          (modalItem.value?.report_uploaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(File06), { size: 20 })
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(modalItem.value?.report_filename), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "action__download",
                    onClick: downloadFile
                  }, [
                    _createVNode(_unref(Download01), { size: 16 })
                  ]),
                  (isAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "action__delete",
                        onClick: deleteFile
                      }, [
                        _createVNode(_unref(Trash01), { size: 16 })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (file.value && file.value.size && file.value.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(File06), { size: 20 })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(file.value.name), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString((file.value.size / 1024 / 1024).toFixed(2)) + " MB ", 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "action__delete",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (file.value = null))
                  }, [
                    _createVNode(_unref(Trash01), { size: 16 })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["modal__body--comment", modalItem.value?.report_uploaded ? '' : 'bottom'])
          }, [
            _createVNode(CommonInput, {
              modelValue: comment.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((comment).value = $event)),
              label: "Comment",
              multiline: ""
            }, null, 8, ["modelValue"])
          ], 2),
          (!file.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("input", {
                  ref_key: "fileInput",
                  ref: fileInput,
                  type: "file",
                  hidden: "",
                  onChange: handleFile,
                  accept: "application/pdf, image/jpeg, image/jpg, image/png"
                }, null, 544),
                _createElementVNode("div", {
                  class: "upload-zone",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.fileInput.click())),
                  onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: _withModifiers(handleDrop, ["prevent"])
                }, [
                  _createVNode(_unref(FilePlus02), { size: 16 }),
                  _cache[16] || (_cache[16] = _createTextVNode(" Add file ", -1))
                ], 32)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: addModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addModal).value = $event)),
      title: "Add Inspection",
      onClose: closeAddModal
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(CommonButton, {
            "is-disabled": !addSaveDisabled.value,
            type: "primary",
            label: "Save",
            onClicked: saveAddInspection
          }, null, 8, ["is-disabled"]),
          _createVNode(CommonButton, {
            type: "outline",
            label: "Back",
            onClicked: closeAddModal
          })
        ])
      ]),
      default: _withCtx(() => [
        (addModalItem.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(CustomTableDropdown, {
                  modelValue: addModalItem.value.company_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addModalItem.value.company_id) = $event)),
                  items: companyItems.value,
                  label: "Company",
                  position: "bottom",
                  clearable: "",
                  fullWidth: "",
                  isAppendItem: "",
                  dropdownFullWidth: "",
                  onSearch: searchCompany,
                  creatable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(CustomTableDropdown, {
                  modelValue: addModalItem.value.driver_id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addModalItem.value.driver_id) = $event)),
                  items: driverItems.value,
                  label: "Driver",
                  fullWidth: "",
                  clearable: "",
                  position: "bottom",
                  isAppendItem: "",
                  creatable: "",
                  onSearch: searchDriver
                }, null, 8, ["modelValue", "items"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_unref(VueDatePicker), {
                  placeholder: "Start date",
                  class: "time",
                  "model-type": "iso",
                  modelValue: addModalItem.value.start_date,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addModalItem.value.start_date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(VueDatePicker), {
                  placeholder: "Processed date",
                  class: "time",
                  "model-type": "iso",
                  modelValue: addModalItem.value.processed_time,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addModalItem.value.processed_time) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(VueDatePicker), {
                  placeholder: "End date",
                  class: "time",
                  "model-type": "iso",
                  modelValue: addModalItem.value.end_date,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((addModalItem.value.end_date) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(CommonInput, {
                  modelValue: addModalItem.value.comment,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((addModalItem.value.comment) = $event)),
                  label: "Comment",
                  multiline: ""
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})